

export enum ReservationState {
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  WAITING = 'WAITING',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
};
